export function toISformatting(num, decimals = 2) {
  let numb = num;
  if (typeof numb === 'string') numb = Number(numb);
  return numb
    .toFixed(decimals) // always two decimal digits
    .replace('.', ',') // replace decimal point character with comma
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.'); // use . as a separator
}
